(function ($) {
  function ConvertCurrencyToString(currency){
    return Shopify.formatMoney(currency * 100, window.myprice);
  }

  function removeAccents(str) {
    var AccentsMap = [
      "aàảãáạăằẳẵắặâầẩẫấậ",
      "AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ",
      "dđ", "DĐ",
      "eèẻẽéẹêềểễếệ",
      "EÈẺẼÉẸÊỀỂỄẾỆ",
      "iìỉĩíị",
      "IÌỈĨÍỊ",
      "oòỏõóọôồổỗốộơờởỡớợ",
      "OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ",
      "uùủũúụưừửữứự",
      "UÙỦŨÚỤƯỪỬỮỨỰ",
      "yỳỷỹýỵ",
      "YỲỶỸÝỴ"
    ];
    for (var i=0; i<AccentsMap.length; i++) {
      var re = new RegExp('[' + AccentsMap[i].substr(1) + ']', 'g');
      var char = AccentsMap[i][0];
      str = str.replace(re, char);
    }
    return str;
  }

  function getColor(color) {
    const enColor = removeAccents(color).trim().toLowerCase();
    return theme.colors[enColor] || enColor;
  }

  function calculatDiscountPrice(item, price) {
    var discount = parseInt(item.discount_value);
    var disPrice = (100 + discount) * price / 100;

    if(item.discount_type === 'fixed_amount') {
      disPrice = price + discount;
    }

    return disPrice;
  }


  function generateDiscountText(item) {
    var value = parseFloat(item.discount_value) * -1;

    if(item.discount_type === 'fixed_amount') {
      return `Tiết kiệm thêm ${ConvertCurrencyToString(value)} khi mua hàng!`;
    }

    return "Tiết kiệm thêm" + " " + value + "% khi mua hàng!";
  }

  function renderPwpSeaItems(item, productIndex) {
    let hasVariants = '';
    
    var priceNot0 = item?.variants.filter((variant) => {
      return variant.price > 0;
    });

    if(!priceNot0.length) return;

    let selectedVariant = priceNot0[0];

    let productFormId = "product_form_" + item.id + "_" + productIndex;
    let productWrapperId = "product_wrapper_" + item.id + "_" + productIndex;
    let urlImage = selectedVariant?.image;
    let productName = !item.title ? "Product title here..." : item.title.length > 50 ? item.title.substring(0, 50) + '...' : item.title;
    var hideOldPrice = "";

    // AA tracking value
    var priceValue = selectedVariant?.compareAtPrice;
    var discountPriceValue = selectedVariant?.price;
    var productTags = item.tags;
    var modelValue = '';
    var superModelValue = '';
    var categoryValue = '';

    if (productTags) {
      productTags.forEach(function (value) {
        if (value.includes('__model:')) {
          modelValue = value.replace('__model:','');
        };

        if (value.includes('__superModel:')) {
          superModelValue = value.replace('__superModel:','');
        };

        if (value.includes('_sixdcode:')) {
          categoryValue = value.replace('_sixdcode:','');
        };
      });
    }

    if (selectedVariant?.compareAtPrice <= selectedVariant?.price || !selectedVariant?.compareAtPrice) {
      hideOldPrice = "display:none;";
    }

    if (item.variants.length) {
      hasVariants = 'has-variants';
    }

    var product =  `
      <div class='grid__cell pwp-product 1/2--handheld-and-up 1/4--desk'>
        <div class="product-item product-${item.id}_${productIndex} product-item--push" data-allow-selecting-sold-out-variants="true">
          <figure class='product-item__image-container'>
            <div class='product-item__image-wrapper'>
              <a href='/products/${item.handle}'>
                <div class='aspect-ratio'>
                  <img class='product-item__image lazyload image--fade-in' alt="${productName}" src="${urlImage}"/>
                </div>
              </a>
            </div>
          </figure>

          <div class='product-item__info'>
            <h3 class='product-item__title'>
              <a href='/products/${item.handle}' class='link'>
                ${item.title}
              </a>
            </h3>

            <div class='bv-ratings-block'>
              <div data-bv-show='inline_rating' 
                data-bv-product-id='${item.handle}' 
                data-bv-redirect-url='/products/${item.handle}' data-bv-seo='false'>
              </div>
            </div>

            <div class='product-content-bottom' id='${productWrapperId}'>
              <span class='product-item__price product-item__price--new'>
                ${ConvertCurrencyToString(calculatDiscountPrice(item, selectedVariant?.price))}
              </span>

              <div class='tooltip-wrapper'>
                <span class='price-tooltip'>1</span>
                <div class='tooltip-content'>
                  <p>
                    1. Prices indicated refer to Suggested Retail Price which includes VAT andmay change from time to time without prior notice.
                  </p>
                </div>
              </div>

              <span class='product-item__price product-item__price--old' style='${hideOldPrice}'>
                ${ConvertCurrencyToString(selectedVariant?.compareAtPrice)}
              </span>

              <div class='product-discount_text'>
                ${generateDiscountText(item)}
              </div>

              <div id="${productFormId}" class='product__form'>
                <input type='hidden' name='model_${item.id}' value='${modelValue}' />
                <input type='hidden' name='superModel_${item.id}' value='${superModelValue}' />
                <input type='hidden' name='sixdcode_${item.id}' value='${categoryValue}' />
                <input type='hidden' name='quantity' value='1' />
                <input type='hidden' name='id' value='${selectedVariant?.d2c_id}' />
                <input type='hidden' name='productId' value='${item.id}' />
                <input type='hidden' name='sku' value='${selectedVariant.sku || ""}' />
                <input type='hidden' name='single-compare-at-price' value='${priceValue}' />
                <input type='hidden' name='single-price' value='${discountPriceValue}' />

                <div class='product-item__add-to-cart button-wrapper ${hasVariants}'>
                  <button data-id='${productFormId}' type='button' class='product__add-to-cart add-cart-pwp button button--primary button--orange'> 
                    ${window.languages.productFormAddToCart} 
                  </button>
                </div>
              </div>

              <div style='font-size: 12px; color: #2f353d; text-align: center; margin-top: 5px;'>
                <p style='font-size: 13px; margin-bottom: 0px;'>
                  Đừng bỏ lỡ, lưu mã ngay!
                </p>
                <span>
                  <button style='border: none; font-size: 14px; background-color: transparent; font-weight: bold; color: #2f353d' class='copy-to-clipboard' title='Copied'>
                    <svg class='icon icon-wishlist'>
                      <use xlink:href='#icon-copy'></use>
                    </svg>
                    <span>${item.discount_code}</span>

                    <input style='display: none;' type='text' name='discount-code' value='${item.discount_code}'/>
                  </button>
                </span>
              </div>

              <div class="rte">
                *Nhập mã khi thanh toán để hưởng ngay ưu đãi!
              </div>
            </div>
          </div>

          <div class='product-item__see-more button-wrapper'>
            <a href='/products/${item.handle}' class='button button--primary'>
              Xem chi tiết
            </a>
          </div>
        </div>
      </div>
    `;

    var pageWrapper = document.getElementById("list_product_pwp");

    if (pageWrapper.innerHTML.length == 199) {
      pageWrapper.childNodes[1].remove();
    }
    
    pageWrapper.innerHTML = pageWrapper.innerHTML + product;
    
    if (item.variants.length) {
      var color_label = 'color,colour,couleur,colore,farbe,색,色,färg,farve';
      let colorSwatchIndex = item.id + "-color-swatch-" + productIndex + "-";
      
      let mainVariants = 
          " <div class='product__variants '>\n" +
          "  <div class='form__control  variant-colour' style='margin-bottom: 0;'>\n" +
          "    <ul class='product__available-colors list--unstyled' data-selector-type='color'>\n" +
          "      [[Color-Options]]</ul>\n" +
          "   </div>\n" +
          " </div>\n";

      var options = "";
      var optionColors = [];

      item.variants
        .forEach((variant, index) => {
          const color = variant.selected_options.find(option => color_label.includes(option.name.toLowerCase()))?.value ?? "";

          if (variant.price === 0 || !color || optionColors.includes(color)) {
            return;
          }

          optionColors.push(color);

          const isSelected = selectedVariant?.d2c_id === variant.d2c_id;
          let checked = "";
          let colorWhite = "";
    
          if (isSelected) {
            checked = "checked='checked'";
    
            $('#' + productFormId + ' .product-item__add-to-cart button').html("Add To Cart <span title='"+ color +"'>("+ color +")</span>");
          }
    
          if (color.toLowerCase() == 'white' || color.toLowerCase() == 'cream' ){
            colorWhite = "color-swatch--white";
          }

          let option = `
            <li class="product__color ${variant.d2c_id}_${productIndex}_${index}"
              title="${color}"
              data-point="${index}"
              data-sku="${variant.sku}"
              data-variant-id="${variant.d2c_id}"
              data-old-price="${variant.compareAtPrice}"
              data-price="${variant.price}"
              data-new-price="${calculatDiscountPrice(item, variant?.price)}"
              data-image-src="${variant.image}"
            >
              <input data-option-index="option1" 
                type="radio"
                value="color"
                ${checked}
                class="single-option-selector"
                id="${colorSwatchIndex}${index}"
                data-main-button="${productFormId}"
                name="single-option-selector-pwp-${productIndex}"
              />
              <label for="${colorSwatchIndex}${index}"
                tabindex='0'
                class="color-swatch ${colorWhite}"
                style="background-color: ${getColor(color)}"
              >
                <span>Color</span>
              </label>
              <svg class='icon icon-tick'><use xlink:href='#icon-tick'></use></svg>
            </li>
          `;
    
          options += option;
          
        });

      if (options === "") {
        options = "<span class='no-color-swatch'>&nbsp;</span>";
      }

      mainVariants = mainVariants.replace("[[Color-Options]]", options);
  
      var variantWrapper = $(".product-" + item.id + "_" + productIndex + " .product-item__info");
      
      variantWrapper.prepend(mainVariants);
    }

    else {
      $(".product-" + item.id + "_" + productIndex + " .product-item__info").prepend("<span class='no-color-swatch'>&nbsp;</span>");
    }

  }

  function loadProductPWP(productId, variantId, collectionsId){
    callAPIWithGWXToken('product/pwp_sea', 'POST', {
      d2c_parent_id: productId,
      d2c_id: variantId,
      collections: collectionsId
    }).then((res) => {
      if (res.data?.pwp_sosc?.length > 0) {
        document.getElementById("shopify-section-pwp-products").style.display = 'block';

        const products = res.data.pwp_sosc.flatMap(item => {
          const products = item.products;
          return products.map(product => ({
            ...product,
            discount_code: item.discount_code,
            discount_type: item.discount_type,
            discount_value: item.discount_value,
            discount_text: item.discount_text
          }))
        });

        products.forEach(renderPwpSeaItems);
  
        var wrapperContainer = $("#list_product_pwp");
  
        // trigger change to load the selected image
        wrapperContainer.find('.single-option-selector:checked').trigger('change');
  
        if (wrapperContainer.hasClass("slick-initialized")) {
            wrapperContainer.slick('unslick');
        }
  
        if(!wrapperContainer.hasClass('slick-initialized')) {
          wrapperContainer.slick({
              infinite: false,
              dots: false,
              arrows: true,
              adaptiveHeight: false,
              mobileFirst: true,
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              pauseOnHover: false,
              accessibility: false,
              useCSS: true,
              prevArrow: '<button title="Prev" class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><span>Prev</span><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
              nextArrow: '<button title="Next" class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><span>Next</span><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>',
              responsive: [
                {
                  breakpoint: 560,
                  settings: {
                      slidesToShow: 2
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 3
                  }
                },
                {
                  breakpoint: 1025,
                  settings: {
                      slidesToShow: 4
                  }
                }
              ]
          })
        }
      }
      else {
        document.getElementById("shopify-section-pwp-products").style.display = 'none';
      }
    })
  }

  $(document).ready(function (e) {
    let component = $('#shopify-section-pwp-products');

    if (component.length != 0){
      var productId = $(component).data('productid');
      var variantId = $(component).data('variantid');
      var collectionsId = $(component).data('collectionsId');

      if ($('#product-detail-' + productId + ' button.product__add-to-cart:disabled').length == 0)
        loadProductPWP(productId, variantId, collectionsId);
    } 
  });

  $('#pwp_products_container').on('click', '.add-cart-pwp', async function (e) { 
    var self = $(this);
    self.attr('disabled', 'disabled').addClass('button--loading');

    var elementId = self.data('id');
    var element = $('#' + elementId);
    var id = element.children('input[name="id"]').val();
    const isLimitQtyPerOrder = window.theme.limit_qty_per_order_enable ? true : false;
    
    // Adobe analytics Event Addtocart
    var skuValue = element.children('input[name="sku"]').val();
    var modelValue = element.children('input[name^="model_"]').val();
    var supperModelValue = element.children('input[name^="superModel_"]').val();
    var categoryValue = element.children('input[name^="sixdcode_"]').val();
    var priceValue = element.children('input[name="single-compare-at-price"]').val();
    var discountPriceValue = element.children('input[name="single-price"]').val();
    var quantityValue = element.children('input[name^="quantity"]').val();

    if (priceValue !== '0' || priceValue !== 'undefined') {
      priceValue = priceValue;
    } else {
      priceValue = discountPriceValue;
    }
    var discountValue = Math.floor((priceValue - discountPriceValue) * 100 / priceValue);
    var dataGWTProduct;

    try {
      dataGWTProduct = await getGWTdataProductDetail(`${skuValue}`);
    } catch (error) {
      dataGWTProduct = null;   
    }
            
    const detailItems = {
      sku: [skuValue],
      model: [modelValue],
      superModel: [supperModelValue],
      quantity: [quantityValue],
      category: [categoryValue],
      price: [Shopify.formatMoney(priceValue)],
      discount: [discountValue],
      discountprice: [Shopify.formatMoney(discountPriceValue)],
      loyaltyPoints: String(((discountPriceValue / 100) / 1000) * 1),
      gwCategory1: [dataGWTProduct?.data?.mainCategory?.[0] || ''],
      gwCategory2: [dataGWTProduct?.data?.mainCategory?.[1] || ''],
      gwCategory3: [dataGWTProduct?.data?.mainCategory?.[2] || ''],
      gwSku: [dataGWTProduct?.data?.sku || ''],
      gwModel: [dataGWTProduct?.data?.modelName || ''],
      gwSupermodel: [dataGWTProduct?.data?.superModelName || ''],
      promoLabel: window.theme.template === 'collection' ? '' : window?.productPromoLabelsList || []
    };
    
    var event = new CustomEvent("addToCart", {
      detail: detailItems 
    });
    
    document.dispatchEvent(event);

    const lineItemData = {
      item_id: id,
      quantity: 1,
    }

    $.ajax({
      method: 'GET',
      url: '/cart.js',
      dataType: 'json'
    }).then(function(cart) {
      const result = cart.items.find((item, idx) => {
        return item.id == id;
      });

      if(isLimitQtyPerOrder && result) {
        self.removeAttr('disabled').removeClass('button--loading');
        alert(window.theme.limit_qty_per_order_err_mes);
      }
      else {
        callAPIWithGWXToken('cart/add', 'POST', {
          is_buy_now: false,
          line_items: [lineItemData]
        }).then(res => {
          if (!res?.warning?.length && (res?.status_code === 200 || res?.status_code === 201)) {
            document.dispatchEvent(new CustomEvent('gwx_showMinicart'));
          } else {
            var addToCartVariant = self.find("> span").text();
            self.text(window.languages.sold_out_message);
            self.attr("old-text", addToCartVariant);
    
            setTimeout(function() {
              self.text(window.languages.productFormAddToCart);
              var attr = self.attr('old-text');
    
              if (typeof attr !== typeof undefined && attr !== "") {
                self.append("<span>" + attr + "</span>");
              }
            }, 2500);
          }
        }).catch(err => {
          console.log("Add to cart error", err);
          
        }).finally(() => {
          self.removeAttr('disabled').removeClass('button--loading');
        })
      }
    })
  });

  $('#pwp_products_container').on('change', '.single-option-selector', function (e) {
    var formId = $(this).data('main-button');
    var mainOption = $(this).parent();
    var variantId = mainOption.data('variant-id');
    var newPrice = mainOption.data('new-price');
    var price = mainOption.data('price');
    var oldPrice = mainOption.data('old-price');
    var imageSrc = mainOption.data('image-src');
    var sku = mainOption.data('sku');
    var strNewPrice = ConvertCurrencyToString(newPrice);
    var colorText = mainOption.attr('title');
    var productId = $(this).attr('id').split('-')[0];
    var productIndex = $(this).attr('id').split('-')[3];
    
    var element = $('#' + formId);

    element.children('input[name="id"]').val(variantId);
    element.children('input[name="sku"]').val(sku);
    element.children('input[name="single-compare-at-price"]').val(oldPrice);
    element.children('input[name="single-price"]').val(price);
    
    var parentElement = element.parent();
    
    parentElement.children('.product-item__price--new').text(strNewPrice);
    
    if (oldPrice > newPrice) {
      var strOldPrice = ConvertCurrencyToString(oldPrice);

      parentElement.children('.product-item__price--old').text(strOldPrice);
      parentElement.children('.product-item__price--old').css('display', 'inline-block');
    }
    else {
      parentElement.children('.product-item__price--old').css('display', 'none');
    }
    
    $('#' + formId + ' .product-item__add-to-cart button').html(window.languages.productFormAddToCart + " <span title='"+ colorText +"'>("+ colorText +")</span>");
    if (imageSrc && imageSrc !== "undefined") {
      $('.product-' + productId + '_' + productIndex).find("img").attr("src",imageSrc);
    }
  });
  
  $('#pwp_products_container').on('click', '.copy-to-clipboard', function (e) {
    var element = $(this);
    var copyText = element.children('input[name="discount-code"]');
    var discountCode = element.children('span').text();
    
    copyText.show();
    /* Select the text field */
    copyText.select();
    element.css("color", "#1f2024");
    document.execCommand("copy");
    copyText.hide();
    element.children('span').text('Copied');

    setTimeout(function() {
      element.css("color", '#808080');
      element.children('span').text(discountCode);
    }, 800)
  });

}(jQuery));
